import React from 'react';
import { useSelector } from 'react-redux';
import ComplianceViolationsFunctional from './components/compliance-violations-functional';
import UnauthorizedAccess from 'src/helpers/UnauthorizedAccess';

const AuthorizedAccess = UnauthorizedAccess(ComplianceViolationsFunctional);

const ComplianceViolationsPage = () => {
	let currentClaims = useSelector((state) => state?.sharedStates?.currentUser?.claims);
	return <AuthorizedAccess {...{ currentClaims, UserClaims: 'Manage.Employees' }} />;
};

export default ComplianceViolationsPage;
